export default "__VITE_ASSET__CgrmVBYO__"